export default {
  SET_UNREAD_MESSAGE_COUNT: "SET_UNREAD_MESSAGE_COUNT",
};
